/**
 * 统计-管理方
 */

import BaseAuthClient from './baseAuth';

class StatisticClient extends BaseAuthClient {
  constructor() {
    super({
      baseURL: '/api'
    });
  }
}

const statisticClient = new StatisticClient();

export default statisticClient;

// 数据总览
// 卡片数据（管理方）
export const getManagerStatistics = (option: any) =>
  statisticClient.get(`/v1/manager/statistics`, option);

// 图表数据
export const getAdminChartData = (option: any) => statisticClient.get(`/v1/datastatistics/getadminchartdata`, option);
// 获取创作环节列表
export const getAdminLinkList = (option: any) => statisticClient.get(`/v1/datastatistics/getlinklistofadmin`, option);


// 卡片数据（创作方-管理方）
export const getUserStatistics = (option: any) =>
  statisticClient.get(`/v1/manager/userstatistics`, option);
// 卡片数据(创作方-创作方)
export const getProuserStatistics = (option: any) =>
  statisticClient.get(`/v1/manager/prouserstatistics`, option);

// 数据明细
// 任务情况明细
export const taskCycleAdminDetail = (option: any) =>
  statisticClient.get(`/v1/workbench/taskcycleofadmin`, option);
// 过审情况明细
export const retrialCycleAdminDetail = (option: any) =>
  statisticClient.get(`/v1/workbench/retrialcycleofadmin`, option);
// 逾期审批明细
export const overdueApproveAdminDetail = (option: any) =>
  statisticClient.get(`/v1/workbench/overdueapproveofadmin`, option);
// 逾期情况明细
export const overdueCycleAdminDetail = (option: any) =>
  statisticClient.get(`/v1/workbench/getoverduecycleofadmin`, option);
// 逾期提交明细
export const overdueSubAdminDetail = (option: any) =>
  statisticClient.get(`/v1/workbench/overduesubofadmin`, option);
// 目标情况明细
export const targetCycleAdminDetail = (option: any) =>
  statisticClient.get(`/v1/workbench/gettargetcycleofadmin`, option);
// 审批明细
export const approveAdminDetail = (option: any) =>
  statisticClient.get(`/v1/manager/instances`, option);

// 修改逾期
export const reviseOverdue = (option: any) =>
  statisticClient.post(`/v1/workbench/reviseoverdue`, option);
// 修改格子
export const reviseCellnum = (option: any) =>
  statisticClient.post(`/v1/workbench/revisecellnum`, option);
// 格子修改记录
export const reviseLog = (option: any) =>
  statisticClient.get(`/v1/workbench/reviselog`, option);
// 逾期修改记录
export const reviseOverdueLog = (option: any) =>
  statisticClient.get(`/v1/workbench/reviseoverduelog`, option);
// 按环节情况统计【管理方】
export const linkStatistics = (option: any) =>
  statisticClient.get(`/v1/link/statistics`, option);

export const getUserLinks = (option: any) =>
  statisticClient.get(`/v1/link/getuserlinks`, option);
// 获取项目预算
export const getProjectBudget = (option: any) =>
  statisticClient.get(`/v1/project/getprojectbudget`, option);

// 设置项目成本
export const setProjectBudget = (option: any) =>
  statisticClient.post(`/v1/project/setprojectbudget`, option);

// 获取环节结算
export const getLinkSetlle = (option: any) =>
  statisticClient.get(`/v1/link/getlinksetlle`, option);

// 设置环节结算
export const setLinkSettle = (option: any) =>
  statisticClient.post(`/v1/link/setlinksettle`, option);

